import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';

/**
 * Use
 * This is used on the home D icon to create the
 * Also used on all the screens layouts that a cycled through
 */
export class IsometricGridLayout implements particles.ParticleLayout {
	public get(
		count: number,
		position: geometry.Vector2,
		size: geometry.Size,
		config: any = null
	): Array<particles.ParticleLookupProps> {
		const SQ3 = Math.sqrt(3);
		const SQ32 = Math.sqrt(3) / 2;
		const offset = 0.05;
		const D = offset;
		const rows = 42;
		const cols = 50;

		let points: Array<particles.ParticleLookupProps> = [];
		let relativeX: number = position.x;
		let relativeY: number = position.y;

		for (let i = 0; i < rows; i++) {
			for (let j = 0; j < cols; j++) {
				const y = (i * (D * 0.5)) / 2;
				const x = j * D * SQ3 + (1 - (i % 2)) * D * SQ32;

				let thisIndex = points.length;
				let upLineIndex = -1;
				let downLineIndex = -1;

				if (i > 0 && j < cols) {
					//Even
					if (i % 2 != 0 && j > 0) upLineIndex = thisIndex - (cols + 1);
					else if (i % 2 == 0 && j < cols - 1) upLineIndex = thisIndex - (cols - 1);
				}

				if (i % 2 == 0 || j > 0) {
					downLineIndex = thisIndex + cols;
				}



				points.push({
					x: relativeX + x / 3,
					y: relativeY + y,
					upLineIndex: upLineIndex,
					downLineIndex: downLineIndex
				});
			}
		}


		return points;
	}
}
